import { TagsEditor, TagsEditorState } from '@tableau/vizportalclient-common-components';
import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { SearchSuggestionsService } from '~src/spacesPlatform/services/SearchSuggestionsService';
import { ITag } from '~src/tags/ITag';

export type ChangeTagsDialogBodyProps = {
  description: string;
  itemCount: number;
}

export type ChangeTagsDialogProps = ReactActionDialogBodyProps<ChangeTagsDialogBodyProps, TagsEditorState>;

function handleFilterItems(partialText: string): Promise<readonly string[]> {
  return SearchSuggestionsService.tags(partialText)
      .getSlice(0, 10)
      .then((result: ListResult<ITag>) => {
        return result.items.map((value: ITag) => value.name);
  });
}

export function ChangeTagsDialogBody(props: ChangeTagsDialogProps): JSX.Element {
  return <TagsEditor
    editorState={props.dialogState}
    setEditorState={props.updateDialogState}
    searchMatchingTags={handleFilterItems}
    disableEditor={props.actionBusy}
    label={props.description}
    itemCount={props.itemCount}
  />;
}

